import React, { useState } from 'react';
import { TooltipHost, TooltipOverflowMode, Selection, IconButton, ShimmeredDetailsList } from '@fluentui/react';
import './DataList.css';
import InlineMenu from '../../InlineMenu/InLineMenu';
import FilterMenusOnState from '../../../../Utils/State/FilterMenusOnState';
import ArcCallout from '../../ArcCallout/ArcCallout';
import TranslateTag from '../../../../Utils/Local/TranslateTag';

const DataList = (props) => {

    let selectionModel;
    const selectionChangeHandler = () => {
        props.selectionChanged(selectionModel);
    };

    const [showContextualMenu, updateShowContextualMenu] = useState({ visible: false, target: ""});
    const [renderCallout, setRenderCallout] = useState(null);
    const [renderEvent, setRenderEvent] = useState(null);
    const [triggerCallout, setTriggerCallout] = useState(false);
    
    if (props.multiSelect) {
        selectionModel = new Selection({selectionMode: 2, getKey: item => item.id, onSelectionChanged: selectionChangeHandler});
    } else {
        selectionModel = new Selection({selectionMode: 1, getKey: item => item.id, onSelectionChanged: selectionChangeHandler});
    }

    if (props.selectionModel !== undefined && props.selectionModel !== null) {
        selectionModel = props.selectionModel;
    }

    const calloutProps = { gapSpace: 10 };
    let tooltipId = 1;

    const onColumnClick = (event, column) => {
        if (props.updateSortedColumn !== undefined) {
            props.updateSortedColumn(column.fieldName);
        }
    }

    const menuItemClicked = (onClick, button, index) => {
        if (props.basic) {
            props.basicModeButtonHandler(props.data[index], button);
        } else {
            onClick();
        }
    };

    const renderItemColumn = (item, index, column) => {
        const fieldContent = item[column.fieldName];
        switch (column.key) {
            case 'menu':
                const stateId = item.stateid === undefined ? item.StateId : item.stateid;
                let menuItems = FilterMenusOnState(props.menuItems, stateId);
                menuItems = menuItems.filter((item) => {
                    return item.primaryAction !== undefined && item.primaryAction !== 0;
                })
                menuItems = menuItems.slice(0,3);
                if (menuItems.length > 0 ) {
                    return (
                        <div>
                            {menuItems.map((menuItem) => {
                                if (menuItem.primaryAction !== undefined && menuItem.primaryAction !== 0) {
                                    return (
                                        <TooltipHost
                                            key={menuItem.key}
                                            content={menuItem.text}
                                            id={tooltipId++}
                                            calloutProps={calloutProps}>
                                            <IconButton
                                                iconProps={menuItem.iconProps}
                                                onClick={() => {menuItemClicked(menuItem.onClick, menuItem.button, index)}}
                                                styles={{
                                                    root: { height: '20px', verticalAlign: 'middle', textAlign: 'left' }
                                                }}
                                            />
                                        </TooltipHost>
                                    )
                                } else {
                                    return null;
                                }   
                            })}
                            <TooltipHost
                                 content={TranslateTag("@GenMor@", props.language)}
                                 id={tooltipId++}
                                 calloutProps={calloutProps}>
                                 <IconButton
                                      iconProps={{ iconName: 'More' }}
                                      onClick={(event) => menuClickHandler(item, event, index)}
                                      styles={{
                                      root: { height: '20px', verticalAlign: 'middle' }
                                 }}
                            />
                            </TooltipHost>
                        </div>
                      );                    
                } else {
                    return (null);
                }
            case "alert":
                const alertTypeId = item.AlertCategoryId === undefined ? item.alertcategoryid : item.AlertCategoryId;
                const alertTitle = item.AlertTitle && item.AlertTitle !== "" ? item.AlertTitle : "Alert";
                const colour = item.Colour === undefined ? item.colour : item.Colour;
                if (alertTypeId !== 989 && alertTypeId !== 990 && alertTypeId !== 991) {
                    return (null)
                } else {
                    if (alertTypeId === 989) {
                        return (
                            <div>
                                <IconButton iconProps={{ iconName: 'AlertSolid'}} title={alertTitle} ariaLabel="Alert"
                                    styles={{
                                        root: { color: colour, height: '10px', width: '10px', verticalAlign: 'middle', textAlign: 'left' }
                                    }}>
                                </IconButton>
                            </div>
                        )                        
                    }
                    if (alertTypeId === 990) {
                        return (
                            <div>
                                <IconButton iconProps={{ iconName: 'WarningSolid' }} title={alertTitle} ariaLabel="Alert"
                                    styles={{
                                        root: { color: colour, height: '10px', width: '10px', verticalAlign: 'middle', textAlign: 'left' }
                                    }}>
                                </IconButton>
                            </div>
                        )                        
                    }
                    if (alertTypeId === 991) {
                        return (
                            <div>
                                <IconButton iconProps={{ iconName: 'InfoSolid' }} title={alertTitle} ariaLabel="Alert"
                                    styles={{
                                        root: { color: colour, height: '10px', width: '10px', verticalAlign: 'middle', textAlign: 'left' }
                                    }}>
                                </IconButton>
                            </div>
                        )                        
                    }
                }
                break;
            default:
                return (
                    <TooltipHost id={item.key} content={fieldContent} overflowMode={TooltipOverflowMode.Parent}>
                        <span>{fieldContent}</span>
                    </TooltipHost>
                )
          }
    };

    let columns = props.columns.map((column) => {
        return { key: column.Key,
                 name: column.Name,
                 fieldName: column.FieldName,
                 minWidth: column.MinWidth,
                 maxWidth: column.MaxWidth,
                 isResizable: column.IsResizable,
                 isCollapsible: column.IsCollapsible,
                 isSorted: column.IsSorted,
                 isSortedDescending: column.IsSortedDescending,
                 highlight: column.Highlight,
                 onColumnClick: onColumnClick
        }
    })

    const menuClickHandler = (item, event, index) => {
        const stateId = item.stateid === undefined ? item.StateId : item.stateid;
        const menuItems = FilterMenusOnState(props.menuItems, stateId);
        if (props.basic) {
            for (let x = 0; x < menuItems.length; x++) {
                menuItems[x].onClick = () => {props.basicModeButtonHandler(props.data[index], menuItems[x].button)};
            }
        }
        updateShowContextualMenu({ visible: true, target: event.target, menuItems: menuItems});
    };

    const closeMenuHandler = () => {
        updateShowContextualMenu({ visible: false, target: ""});
    };

    const itemInvokedHandler = (item, index, event) => {
        if (!props.basic) {
            props.itemInvokedHandler();
        }
    }

    let onRenderRow = undefined;
    if (props.displaySummary) {
        onRenderRow = (props, defaultRender) => {
            return <div onMouseEnter={ (event) => { 
                        setRenderCallout(props.item); 
                        setRenderEvent(event.currentTarget)
                        setTriggerCallout(true)}
                    }
                    onMouseLeave={ (event) => { setTriggerCallout(false)}}>
                {defaultRender(props)}
            </div>
        }
    }

    //Put in place menu on the menu column if required

    const onColumnHeaderClick = (event,object) => {
        if (object.id === "headermenu") {
            props.onClick({UIEvent: props.addButton, OnFinish: 'embeddedrefresh'}, {id: props.parentId})
        }
    }

    if (props.addButton !== undefined && props.addButton !== "") {
        for (const column of columns) {
            if (column.key.toLowerCase() === "menu") {
                column.iconName = "Add";
                column.iconClassName = "datalist-menuicon";
                column.id = "headermenu";
            }
        }
    }

    return (
        <div className="datalist-content">
            <ShimmeredDetailsList
                items={props.data}
                columns={columns}
                onColumnHeaderClick={onColumnHeaderClick}
                onRenderItemColumn={renderItemColumn}
                onRenderRow={onRenderRow}
                selectionMode={props.basic ? 0 : props.multiSelect === true ? 2 : 1}
                selection={selectionModel}
                selectionPreservedOnEmptyClick={true}
                enableShimmer={!props.isDataLoaded}
                compact={true}
                onItemInvoked={itemInvokedHandler}
            />
            <InlineMenu
                showMenu={showContextualMenu.visible}
                closeMenu={closeMenuHandler}
                target={showContextualMenu.target}
                items={showContextualMenu.menuItems}>
            </InlineMenu>

            {renderCallout !== null && (
                <ArcCallout event={renderEvent} item={renderCallout} trigger={triggerCallout}></ArcCallout>
            )}
        </div>
        );

};

export default DataList;
